import { Flex, PersonCard, Text, Image } from "@capioweb/ui-components"
import { QBankImage } from "../../@types/CapioWeb/core"
import Property, {
	LinkProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import { imageBlockDataToImageProps } from "../../utils"
import { sendContactDataLayerPush } from "../../utils/piwikPro"

interface PressContactCardProps {
	contactName: StringProperty
	contactEmailLink: LinkProperty
	contactPhoneLink: LinkProperty
	jobPosition: StringProperty
	imageBlock: QBankImage
}

type PressContactContentAreaProperty = Property<PressContactCardProps[]>

interface CapioPressContactContainerBlockProps {
	heading: StringProperty
	pressContacts: PressContactContentAreaProperty
}

const srcSetSizes = [{ width: 600, breakpoint: 2560 }]

const CapioPressContactContainerBlock: React.FC<CapioPressContactContainerBlockProps> =
	({ pressContacts, ...rest }) => {
		const hasItems = pressContacts?.value?.length > 0
		return (
			<BlockCommonLayout {...rest}>
				<Flex
					flexWrap={{ _: "nowrap", s: "wrap" }}
					flexDirection={{ _: "column", s: "row" }}
					columnGap={3}
					rowGap={{ _: 2, m: 3 }}
					mb={2.5}
					w={1}
				>
					{hasItems &&
						pressContacts.value.map((item, i) => (
							<PersonCard
								maxw={{ _: 1, s: "calc(50% - 12px)" }}
								minw={{ _: 1, m: "calc(50% - 12px)" }}
								key={i}
							>
								<Flex justifyContent="space-between" h={1}>
									<Flex flexDirection="column" py={3.25} px={3} w="calc(66%)">
										{item.contactName && (
											<Text variant="headline-3" mb={0.5}>
												{item.contactName.value}
											</Text>
										)}
										<Flex flexDirection="column" w={1}>
											{item.jobPosition && (
												<Text mb={0}>{item.jobPosition.value}</Text>
											)}
											{item.contactEmailLink?.href && (
												<Text.Anchor
													href={item.contactEmailLink.href}
													textDecoration="underline"
													mb={0}
													onClick={() =>
														sendContactDataLayerPush(
															"mail",
															item.contactEmailLink?.href
														)
													}
												>
													{item.contactEmailLink.text}
												</Text.Anchor>
											)}
											{item.contactPhoneLink?.href && (
												<Text.Anchor
													href={item.contactPhoneLink.href}
													textDecoration="underline"
													mb={0}
													onClick={() =>
														sendContactDataLayerPush(
															"phone",
															item.contactPhoneLink?.href
														)
													}
												>
													{item.contactPhoneLink.text}
												</Text.Anchor>
											)}
										</Flex>
									</Flex>
									<Flex w={"calc(33%)"} maxh={1} position="relative">
										{item.imageBlock?.media?.value?.url && (
											<Flex position="absolute" w={1} h={1}>
												<Image
													{...imageBlockDataToImageProps(
														item.imageBlock,
														true,
														true,
														srcSetSizes
													)}
													style={{ borderRadius: "0 24px 24px 0" }}
												/>
											</Flex>
										)}
									</Flex>
								</Flex>
							</PersonCard>
						))}
				</Flex>
			</BlockCommonLayout>
		)
	}

export { CapioPressContactContainerBlock }
